import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { getMollieInstance } from "../utils/mollie";
import { MollieInstance } from "@/components/Payment/types";
import { config } from "@/config/config";

type MollieContextType = {
    mollie: MollieInstance|null;
    ready: boolean;
};

const MollieContext = createContext<MollieContextType>({ mollie: null, ready: false });

export function MollieProvider({ children }: { children: ReactNode }) {
    const [mollie, setMollie] = useState<MollieInstance| null>(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!document.querySelector('script[src*="mollie"]')) {
            const script = document.createElement("script");
            script.src = config.app.mollie.scriptURL!;
            script.async = true;
            script.onload = () => {
                setMollie(getMollieInstance());
                setReady(true);
            };
            document.head.appendChild(script);
        } else {
            setMollie(getMollieInstance());
            setReady(true);
        }
    }, []);

    return (
        <MollieContext.Provider value={{ mollie, ready }}>
            {children}
        </MollieContext.Provider>
    );
}

export const useMollie = () => useContext(MollieContext);